import { GET_PERIODS_CORE} from './../constants';
import { handleActions } from "redux-actions"

export const periodsCore  = handleActions(
  { 
    [ GET_PERIODS_CORE ]: (state, action) => {
      const {error} = action.payload
      if (error) {
        return state
      } else {
        return action.payload.data
      }
    }
  }, []
)